import './BookStyle.css';
import { useAppSelector } from '../../store/hooks';
import { BookForList, BookLanguagePreset, Language } from '../../rest/models';
import { useNavigate } from 'react-router-dom';
import { DeleteRestObjectButton } from '../../rest/components/DeleteRestObjectButton';
import { getModelArr, getModelMap } from '../../rest/slice';
import { PleaseWait, DictRequestStatusDisplay } from '../CommonComponents';
import { Anchor } from "../RequestRespectingInputs";
import { Button } from "../RequestRespectingInputs";
import { GetPageTitle } from '../../ErnotsConfig';
import { Fragment } from 'react';
import { presetToText as presetToStrings } from './utils';
import { orderBy } from '../../utils';

export function BookList()
{
    const navigate = useNavigate();

    const bookModels = getModelArr(useAppSelector, BookForList);
    const presetModels = getModelArr(useAppSelector, BookLanguagePreset);
    const languageModels = getModelMap(useAppSelector, Language);

    const hasData = bookModels != null && languageModels != null && presetModels != null

    let bookList = <>
        <PleaseWait what='the book table'/>
        <DictRequestStatusDisplay modelClass={BookForList} />
    </>;

    let presetTable = <>
        <PleaseWait what='the preset table'/>
        <DictRequestStatusDisplay modelClass={Language} />
        <DictRequestStatusDisplay modelClass={BookLanguagePreset} />
    </>;

    if (hasData)
    {
        const booksModels2 = orderBy(bookModels, b => b.title);
    
        const bookRows = booksModels2.map(function(eam)
        {
            const b = eam as BookForList;

            const read = <Anchor to={`/book/read/?bookId=${b.id}`}>Read</Anchor>;
            const gtb = <Anchor to={`/book/read/?bookId=${b.id}&goToBookmark=1`}>Go to Bookmark</Anchor>;
            const edit = <Anchor to={`/book/edit/?bookId=${b.id}`}>Edit</Anchor>;
            const drob = <DeleteRestObjectButton object={b} messageOnNewLine={true} link={true}/>;

            return (
                <li key={b.key}>
                    {b.title}
                    <div>{read} {gtb} {edit} {drob}</div>
                    
                    <div>({b.total_sentences} sentences)</div>

                    <hr/>
                </li>);
        });

        bookList = <ol className='ernots_BookList'>{bookRows}</ol>;

        const presetRows = presetModels
            .map(function(eam)
            {
                const p = eam as BookLanguagePreset;
                const strings = presetToStrings(p, languageModels);
                const component = strings
                    ? <tr key={p.key}>
                        <td>{strings.source}</td>
                        <td>{strings.targets}</td>
                        <td>{strings.order}</td>
                        <td className='ernots_CenteredCell'>
                            <Button onClick={e => navigate(`/book/edit/?presetId=${p.key}`)}>Create Book</Button>
                        </td>
                        <td className='ernots_CenteredCell'><DeleteRestObjectButton object={p} messageOnNewLine={true}/></td>
                    </tr>
                    : <Fragment key={p.key}/>

                return {text: strings, component};
            })
            .filter(pr => pr.text);

        const presetRows2 = orderBy(presetRows, pr => pr.text?.comparable ?? '').map(pr => pr.component);

        presetTable = (
            <div>
                <table className='ernots_PresetTable' border={1}>
                    <thead>
                        <tr>
                            <th>Source Language</th>
                            <th>Translation Languages</th>
                            <th>Display Order</th>
                            <th>Create Book from Preset</th>
                            <th>Delete Preset</th>
                        </tr>
                    </thead>
                    <tbody>
                        {presetRows2}
                    </tbody>
                </table>
            </div>);
    }

    return (
    <div>
        <title>{GetPageTitle('Book List')}</title>

        <p><Button onClick={e => navigate(`/book/edit/`)} style={{fontSize: '100%'}}>Create New Book</Button></p>

        {bookList}
        <fieldset>
            <legend>Create a new book using a language preset:</legend>

            Whenever you create a book, the languages you used, in your chosen display order, are used to create a preset.
            Next time, you can select the preset, and the book will be initialized with those languages.
            {presetTable}
        </fieldset>
    </div>);
}